<template>
	<div v-if="showPreview" class="notice-overlay">
		<div class="notice-modal">
			<div class="modal-header">
				<button
					class="close-notice"
					@click="closePreview"
					title="Fermer"
				>
					&times;
				</button>
				<h1>
					{{ title || 'Aperçu du fichier' }}
				</h1>
				<button
					v-if="showDownloadButton"
					class="button button--primary button--small"
					@click="customDownloadFunction"
					title="Télécharger le fichier"
				>
					Télécharger
				</button>
			</div>
			<div class="preview-container">
				<iframe
					v-if="previewUrl"
					:src="previewUrl"
					type="application/pdf"
					allowfullscreen
				></iframe>
				<div v-else class="loading">
					Chargement en cours...
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { previewMedia } from "../../services/mediaService";

export default {
	name: 'FilePreview',
	props: {
		show: {
			type: Boolean,
			default: false
		},
		filePath: {
			type: String,
			default: ''
		},
		title: {
			type: String,
			default: 'Aperçu du fichier'
		},
		showDownloadButton: {
			type: Boolean,
			default: false
		},
		fileName: {
			type: String,
			default: ''
		},
		customDownloadFunction: {
			type: Function,
			default: null
		}
	},
	data() {
		return {
			previewUrl: null
		};
	},
	computed: {
		showPreview() {
			return this.show;
		}
	},
	watch: {
		async show(newVal) {
			if (newVal && this.filePath) {
				await this.loadPreview();
			} else if (!newVal) {
				this.cleanup();
			}
		},
		async filePath(newVal) {
			if (newVal && this.show) {
				await this.loadPreview();
			}
		}
	},
	methods: {
		async loadPreview() {
			try {
				if (this.previewUrl) {
					URL.revokeObjectURL(this.previewUrl);
				}
				
				this.previewUrl = await previewMedia(this.filePath);
				
				if (!this.previewUrl) {
					console.error("Impossible de charger l'aperçu du fichier");
					this.$emit('error', 'Impossible de charger l\'aperçu du fichier');
				}
			} catch (error) {
				console.error("Erreur lors du chargement de l'aperçu:", error);
				this.$emit('error', error.message);
			}
		},
		closePreview() {
			this.cleanup();
			this.$emit('close');
		},
		cleanup() {
			if (this.previewUrl) {
				URL.revokeObjectURL(this.previewUrl);
				this.previewUrl = null;
			}
		}
	},
	unmounted() {
		this.cleanup();
	}
};
</script>

<style scoped>
.notice-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: rgba(0, 0, 0, 0.7);
	z-index: 9999;
	display: flex;
	align-items: center;
	justify-content: center;
}

.notice-modal {
	background: #fff;
	border-radius: 12px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
	padding: 1rem;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	max-width: 90vw;
	max-height: 90vh;
}

.modal-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	margin-bottom: 1rem;
	position: relative;
	padding-right: 50px;
}

.modal-header h1 {
	margin: 0;
	text-align: center;
	width: 90%;
}

iframe {
	border: none;
	background: #fff;
	width: 80vw;
	max-width: 800px;
	height: 80vh;
	max-height: 80vh;
	border-radius: 8px;
	box-shadow: 0 2px 16px rgba(0, 0, 0, 0.15);
}

.close-notice {
	position: absolute;
	top: 0;
	right: 0;
	background: #e74c3c;
	color: #fff;
	border: none;
	border-radius: 50%;
	width: 36px;
	height: 36px;
	font-size: 1.5rem;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: background 0.2s;
	z-index: 10;
}

.close-notice:hover {
	background: #c0392b;
}

.preview-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
}

iframe {
	border: none;
	background: #fff;
	width: 80vw;
	max-width: 800px;
	height: 80vh;
	max-height: 80vh;
	border-radius: 8px;
	box-shadow: 0 2px 16px rgba(0, 0, 0, 0.15);
}

.loading {
	padding: 2rem;
	font-size: 1.2rem;
	color: #666;
}
</style> 